import React from "react";
import styles from "./ToggleSwitch.module.scss";

export const ToggleSwitch = ({ bool, onToggle }) => {
  const [active, setActive] = React.useState(true);

  React.useEffect(() => {
    setActive(bool);
  }, [bool]);

  const handlerChangeActive = () => {
    setActive(!active);
    onToggle(!active);
  };
  return (
    <div
      className={`${styles.toggleSwitch} ${active ? styles.on : ""}`}
      onClick={handlerChangeActive}
    >
      <div className={styles.thumb} />
    </div>
  );
};
